export class AlbumSummary {
  id: string;
  name: string;
  year: number;
  rating: number;
  placeToStart: boolean;
  reviewDate: number;

  deserialize(albumSummaryJson: AlbumSummary): void {
    this.id = albumSummaryJson.id;
    this.name = albumSummaryJson.name;
    this.year = albumSummaryJson.year;
    this.rating = albumSummaryJson.rating;
    this.placeToStart = albumSummaryJson.placeToStart;
    this.reviewDate = albumSummaryJson.reviewDate;
  }

  isPlaceToStart(): boolean {
    return this.placeToStart === true;
  }

  hasReviewDate(): boolean {
    return this.reviewDate && this.reviewDate !== 0;
  }

  getFormattedReviewDate(): string {
    const date = new Date(this.reviewDate);
    const formattedDate = date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
    return formattedDate;
  }
}
